
import { ASSET_CLASS_COLORS, STRATEGY_COLORS } from '@/constants/investmentColors';

// Define color constants for alternative investments
export const ALTS_COLORS = {
  spaceCadet: "#2B2D42",    // Dark blue/gray
  yaleBlue: "#1B3668",      // Deep blue
  yinMnBlue: "#355070",     // Medium blue
  paynesGray: "#4F6D7A",    // Blue gray
  battleshipGray: "#848482", // Medium gray
  lion: "#C6AC8F",          // Light brown
  satinSheenGold: "#CBA135", // Gold
  goldenrod: "#DAA520"       // Darker gold
};

export { ASSET_CLASS_COLORS, STRATEGY_COLORS };
